/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOtherQaEquipmentDto } from './CreateOtherQaEquipmentDto';
import {
    instanceOfCreateOtherQaEquipmentDto,
    CreateOtherQaEquipmentDtoFromJSON,
    CreateOtherQaEquipmentDtoFromJSONTyped,
    CreateOtherQaEquipmentDtoToJSON,
} from './CreateOtherQaEquipmentDto';
import type { CreatePtwQaEquipmentWithRegistrationDto } from './CreatePtwQaEquipmentWithRegistrationDto';
import {
    instanceOfCreatePtwQaEquipmentWithRegistrationDto,
    CreatePtwQaEquipmentWithRegistrationDtoFromJSON,
    CreatePtwQaEquipmentWithRegistrationDtoFromJSONTyped,
    CreatePtwQaEquipmentWithRegistrationDtoToJSON,
} from './CreatePtwQaEquipmentWithRegistrationDto';
import type { CreatePtwQaEquipmentWithSerialNumberDto } from './CreatePtwQaEquipmentWithSerialNumberDto';
import {
    instanceOfCreatePtwQaEquipmentWithSerialNumberDto,
    CreatePtwQaEquipmentWithSerialNumberDtoFromJSON,
    CreatePtwQaEquipmentWithSerialNumberDtoFromJSONTyped,
    CreatePtwQaEquipmentWithSerialNumberDtoToJSON,
} from './CreatePtwQaEquipmentWithSerialNumberDto';
import type { CreatePtwQaEquipmentWithoutSerialNumberDto } from './CreatePtwQaEquipmentWithoutSerialNumberDto';
import {
    instanceOfCreatePtwQaEquipmentWithoutSerialNumberDto,
    CreatePtwQaEquipmentWithoutSerialNumberDtoFromJSON,
    CreatePtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped,
    CreatePtwQaEquipmentWithoutSerialNumberDtoToJSON,
} from './CreatePtwQaEquipmentWithoutSerialNumberDto';
import type { CreateUnicheckDeviceDto } from './CreateUnicheckDeviceDto';
import {
    instanceOfCreateUnicheckDeviceDto,
    CreateUnicheckDeviceDtoFromJSON,
    CreateUnicheckDeviceDtoFromJSONTyped,
    CreateUnicheckDeviceDtoToJSON,
} from './CreateUnicheckDeviceDto';
import type { CreateUnicheckSimulatorDto } from './CreateUnicheckSimulatorDto';
import {
    instanceOfCreateUnicheckSimulatorDto,
    CreateUnicheckSimulatorDtoFromJSON,
    CreateUnicheckSimulatorDtoFromJSONTyped,
    CreateUnicheckSimulatorDtoToJSON,
} from './CreateUnicheckSimulatorDto';

/**
 * @type CreateQaEquipmentRtSystemDto
 * 
 * @export
 */
export type CreateQaEquipmentRtSystemDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateOtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateOtherQaEquipmentDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreatePtwQaEquipmentWithRegistrationDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreatePtwQaEquipmentWithSerialNumberDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreatePtwQaEquipmentWithoutSerialNumberDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateUnicheckDeviceDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateUnicheckSimulatorDto;


export function CreateQaEquipmentRtSystemDtoFromJSON(json: any): CreateQaEquipmentRtSystemDto {
    return CreateQaEquipmentRtSystemDtoFromJSONTyped(json, false);
}

export function CreateQaEquipmentRtSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQaEquipmentRtSystemDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateOtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateOtherQaEquipmentDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateOtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreatePtwQaEquipmentWithRegistrationDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreatePtwQaEquipmentWithSerialNumberDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreatePtwQaEquipmentWithoutSerialNumberDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateUnicheckDeviceDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateUnicheckSimulatorDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of CreateQaEquipmentRtSystemDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateQaEquipmentRtSystemDtoToJSON(value?: CreateQaEquipmentRtSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateOtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateOtherQaEquipmentDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreatePtwQaEquipmentWithRegistrationDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreatePtwQaEquipmentWithSerialNumberDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreatePtwQaEquipmentWithoutSerialNumberDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateUnicheckDeviceDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateUnicheckSimulatorDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateQaEquipmentRtSystemDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateQaEquipmentRtSystemDto interface.
 */
export function instanceOfCreateQaEquipmentRtSystemDto(value: any): value is CreateQaEquipmentRtSystemDto {
    if (instanceOfCreateOtherQaEquipmentDto(value)) return true;
    if (instanceOfCreatePtwQaEquipmentWithRegistrationDto(value)) return true;
    if (instanceOfCreatePtwQaEquipmentWithSerialNumberDto(value)) return true;
    if (instanceOfCreatePtwQaEquipmentWithoutSerialNumberDto(value)) return true;
    if (instanceOfCreateUnicheckDeviceDto(value)) return true;
    if (instanceOfCreateUnicheckSimulatorDto(value)) return true;
    return false;
}

